<template>
    <div class="ConseilGestion">
        <HeadPage :title="'Externalisation des Entretiens Professionnels'" 
                  :category="'Conseil'"
                  :img="'conseil/externalisation.jpg'"
                  :imgAlt="'Externalisation Head Page'"
        />
        <ContentPage :content="content"
        />
    </div>
</template>

<script>
import HeadPage from '../global/HeadPage.vue'
import ContentPage from '../global/ContentPage.vue'

export default {
    name: "ConseilGestion",
    data() {
        return {
            content: [
                { 
                    title: 'Cadre légal', 
                    text: [ `Tous les six ans, l'entretien professionnel fait un <strong>état des lieux récapitulatif 
                    du parcours professionnel du salarié</strong>. Cette durée s'apprécie par référence à l'ancienneté du salarié dans l'entreprise. 
                    Ce dernier donne lieu à la rédaction d'un document dont une copie est remise au salarié, il permet 
                    de vérifier que le salarié a bénéficié au cours des six dernières années des entretiens professionnels prévus 
                    et d'apprécier si :`,
                    `<ul>
                        <li>Il a suivi au moins une action de formation.</li>
                        <li>Il a acquis des éléments de certification par la formation ou par une Validation des Acquis de l'Expérience (VAE).</li>
                        <li>Il a bénéficié d'une progression salariale ou professionnelle.</li>
                    </ul>`,
                    `Dans les <strong>entreprises d'au moins cinquante salariés</strong>, lorsque, au cours de ces six années, le salarié 
                    n'a pas bénéficié des entretiens prévus et d'au moins une formation autre que celle mentionné à l'article L. 6321-2, son compte personnel est 
                    abondé dans les conditions définies à l'article L. 6323-13.`,
                    `Pour permettre aux entreprises de faire face à cette obligation <strong>JobStream</strong> propose une offre personnalisée 
                    « de A à Z » offrant de nombreux avantages pour l'entreprise et pour les salariés.`
                        ]
                },
                { 
                    title: 'Avantages pour votre entreprise', 
                    text: [ `<ul>
                                <li>Gain de temps et concentration sur votre coeur de métier</li>
                                <li>Maintien de la vision sur vos décisions stratégiques</li>
                                <li>Offre globale et sur mesure</li>
                                <li>Conformité légale</li>
                                <li>Engagement de confidentialité</li>
                            </ul>`
                        ]
                },
                { 
                    title: 'Avantages pour vos salariés', 
                    text: [ `<ul>
                                <li>Marque de considération</li>
                                <li>Implication par le partage des enjeux de l'entreprise</li>
                                <li>Dialogue libéré</li>
                                <li>Informations précises sur les dispositifs de formation</li>
                            </ul>`
                        ]
                },
            ]
        }
    },
    components: {
        HeadPage,
        ContentPage
    }
}
</script>